import styled, { css } from "styled-components";
import media from "@pagepro-monorepo/ui/lib/theme/config/media";

import { StyledTestimonialsBulletProps } from "./types";

const wrapperCommonStyles = css<StyledTestimonialsBulletProps>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.primary : theme.colors.white};
  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.white : theme.colors.primary};
  border: 0;
  padding: 1.375rem 0.625rem;
  text-align: left;

  box-shadow: ${({ isActive }) =>
    isActive
      ? "0px 0.625rem 1.5625rem rgba(0, 20, 31, 0.25)"
      : "0px 0px 0px rgba(0, 20, 31, 0.25)"};

  @media ${media.mobile} {
    padding: 1.375rem 1.875rem;
  }
`;

export const Details = styled.span`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Wrapper = styled.button<StyledTestimonialsBulletProps>`
  ${wrapperCommonStyles};
  cursor: pointer;
  transition: ${({ theme }) => theme.transition};
  @media ${media.tablet} {
    &:hover {
      opacity: 0.8;
    }
  }
  ${({ isActive }) =>
    !isActive &&
    css`
      ${Details} {
        opacity: 0.5;
      }
    `}
`;

export const WrapperDiv = styled.div<StyledTestimonialsBulletProps>`
  ${wrapperCommonStyles};
`;

export const Media = styled.span`
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  border-radius: 100vh;
  overflow: hidden;
  margin-right: 1.25rem;
  filter: grayscale(100%);
  transform: translate3d(0, 0, 0);
`;
